<template>
  <div>
    <!-- loader -->
    <!-- <div class="loader-wrapper">
      <div id="loader">
        <div id="shadow"></div>
        <div id="box"></div>
      </div>
    </div> -->
    <!-- loader end -->

   
    <!-- home section -->
    <section class="img-scence-bg-q3 home">
      <div class="animation-circle-inverse">
        <i></i>
        <i></i>
        <i></i>
      </div>
      <div class="animation-circle-inverse absolute">
        <i></i>
        <i></i>
        <i></i>
      </div>
      <div class="container">
        <div class="menu">
          <router-link to="/menu3">    <img 
                  src="../assets/images/menu.png"
                  alt="top5"
                  class="img-fluid"
                  style="width: 100px;"
                /></router-link>
              </div>
              <div class="menu-back">
                <a @click="playsound();$router.go(-1);">
<img
                  src="../assets/images/menu-back.png"
                  alt="top5"
                  class="img-fluid"
                  style="width: 80px;"
                />
</a>
              </div>
              <div class="menu-next">
                <router-link to="/menu3-video-clip">
                <img @click="playsound"
                  src="../assets/images/menu-next.png"
                  alt="top5"
                  class="img-fluid"
                  style="width: 80px;"
                />
                </router-link>
              </div>
              <div class="row justify-content-center" >
       
        
            
       <div class="col-md-6" >
      
         <div class="img-q-right" v-if="state==1">
          <h3 v-html="q1"></h3>
<br><br>
          <b-button size="lg" block  pill variant="outline-primary" v-for="data in answer1" :key="data.id" @click="answerEnter(state,data.id)">{{data.text}}</b-button>
         </div>
         <div class="img-q-right" v-else-if="state==11">
          <h3 v-html="q1"></h3>
<br><br>
          <b-button size="lg" block  pill :variant="data.variant" v-for="data in answer1" :key="data.id" disabled>{{data.text}}</b-button>
         </div>
         <div class="img-q-right" v-else-if="state==2">
          <h3 v-html="q2"></h3><br><br>
          <b-button size="lg" block  pill variant="outline-primary" v-for="data in answer2" :key="data.id" @click="answerEnter(state,data.id)">{{data.text}}</b-button>
         </div>
         <div class="img-q-right" v-else-if="state==22">
          <h3 v-html="q2"></h3><br><br>
          <b-button size="lg" block  pill :variant="data.variant" v-for="data in answer2" :key="data.id" disabled>{{data.text}}</b-button>
         </div>
         <div class="img-q-right" v-else-if="state==3">
          <h3 v-html="q3"></h3><br>
          <b-button size="lg" block  pill variant="outline-primary" v-for="data in answer3" :key="data.id" @click="answerEnter(state,data.id)">{{data.text}}</b-button>
         </div>
         <div class="img-q-right" v-else-if="state==33">
          <h3 v-html="q3"></h3><br>
          <b-button size="lg" block  pill :variant="data.variant" v-for="data in answer3" :key="data.id" disabled>{{data.text}}</b-button>
         </div>
         <div class="img-q-right" v-else-if="state==4">
          <h1 class="text-center" style="margin-top:120px;color:blue">ตอบถูก  {{score}} ข้อ</h1>
      
         </div>
        
       </div>
      
     
     </div>
      </div>
      
    </section>
    <!-- home section end -->

  
    <!--Footer Section End-->
  </div>
</template>
<script>
import InnerImageZoom from 'vue-inner-image-zoom';
import 'vue-inner-image-zoom/lib/vue-inner-image-zoom.css';
import $ from "jquery";
export default {
  components: {
    'inner-image-zoom': InnerImageZoom
  },
  data() {
    return {
      text: "sss",
      score: 0,
      responsiveNav: false,
      responsiveOthePageslist: false,
      responsiveBlogList: false,
      state:1,
      variant: 'outline-primary',
      q1: "ข้อใด<b><u>สะท้อน</u></b>ถึงสิทธิการดูแล",
      answer1 : [
        {id:1,text: 'ก.ผู้ใหญ่ยืนคุยกัน' , result: 'incorrect', variant: 'outline-primary'},
        {id:2,text: 'ข.ผู้ใหญ่ดูเด็กเล่นชิงช้า' , result: 'incorrect', variant: 'outline-primary'},
        {id:3,text: 'ค.ผู้ใหญ่คล้องเชือกสุนัข' , result: 'incorrect', variant: 'outline-primary'},
        {id:4,text: 'ง.ผู้ใหญ่จูงมือเด็กไปเล่น' , result: 'correct', variant: 'outline-primary'},
      ],
      q2: "ข้อใด<b><u>สะท้อน</u></b>ถึงความรับผิดชอบ",
      answer2 : [
        {id:1,text: 'ก.เด็กทิ้งขยะลงถัง' , result: 'correct', variant: 'outline-primary'},
        {id:2,text: 'ข.เด็กยืนดูเพื่อนเล่น' , result: 'incorrect', variant: 'outline-primary'},
        {id:3,text: 'ค.เด็กชวนเพื่อนมาเล่น' , result: 'incorrect', variant: 'outline-primary'},
        {id:4,text: 'ง.เด็กโบกมือเรียกเพื่อน' , result: 'icorrect', variant: 'outline-primary'},
      ],
      q3: "ข้อใด<b><u>ไม่สะท้อน</u></b>ถึงสิทธิและความรับผิดชอบ",
      answer3 : [
        {id:1,text: 'ก.การทิ้งลงถังขยะ' , result: 'incorrect', variant: 'outline-primary'},
        {id:2,text: 'ข.การพูดคุยกัน' , result: 'correct', variant: 'outline-primary'},
        {id:3,text: 'ค.การดูแลเด็กเล็ก' , result: 'incorrect', variant: 'outline-primary'},
        {id:4,text: 'ง.การเล่นกับเด็กทุกคน' , result: 'incorrect', variant: 'outline-primary'},
      ]
    };
  },
  mounted() {
   // this.loader();
   
  },
  methods: {
    changeScreen(state){
      var v = this;
      setTimeout(function () { (v.state = state) }, 1000);
    
    },
    playsound(){
      var audio = new Audio('./click.mp3');
				audio.play();
    },
    answerEnter(state,id) {
      var audio = new Audio('./click.mp3');
				audio.play();
      if(state == 1){
        this.state = 11
        const resultData = this.answer1.filter((item) => item.id == id );
      console.log(resultData[0].variant)
    
      if(resultData[0].result == 'incorrect'){
  
       const objIndex = this.answer1.findIndex(obj => obj.id == id);
        this.answer1[objIndex].variant = "warning"
       
      } else if(resultData[0].result == 'correct'){
        this.score++
        const objIndex = this.answer1.findIndex(obj => obj.id == id);
        this.answer1[objIndex].variant = "success"
  
 }
   this.changeScreen(2)

      }
      else if(state == 2){
        this.state = 22
        const resultData = this.answer2.filter((item) => item.id == id );
      console.log(resultData[0].variant)
    
      if(resultData[0].result == 'incorrect'){
  
       const objIndex = this.answer2.findIndex(obj => obj.id == id);
        this.answer2[objIndex].variant = "warning"
       
      } else if(resultData[0].result == 'correct'){
        this.score++
        const objIndex = this.answer2.findIndex(obj => obj.id == id);
        this.answer2[objIndex].variant = "success"
  
 }
   this.changeScreen(3)
      }
      else if(state == 3){
       this.state = 33 
       const resultData = this.answer3.filter((item) => item.id == id );
      console.log(resultData[0].variant)
    
      if(resultData[0].result == 'incorrect'){
  
       const objIndex = this.answer3.findIndex(obj => obj.id == id);
        this.answer3[objIndex].variant = "warning"
       
      } else if(resultData[0].result == 'correct'){
        this.score++
        const objIndex = this.answer3.findIndex(obj => obj.id == id);
        this.answer3[objIndex].variant = "success"
  
 }
   this.changeScreen(4)
       
      }
   
      

    },
    
    loader() {
      $(document).ready(function () {
        $(window).on("load", function () {
          $(".loader-wrapper").fadeOut("slow");
          $(".loader-wrapper").remove("slow");
        });
      });
    },
    toggleNavbar(toToggle) {
      if (toToggle === "navbar") {
        this.responsiveNav = !this.responsiveNav;
      } else if (toToggle === "blogList") {
        this.responsiveBlogList = !this.responsiveBlogList;
      } else if (toToggle === "otherPagesList") {
        this.responsiveOthePageslist = !this.responsiveOthePageslist;
      }
    },
  },
  beforeCreate: function () {
    document.body.className = "landing-page";
  },
};
</script>
<style scoped>
.navbar {
  position: absolute;
}
</style>
